import { useEffect, useMemo } from 'react';
import moment, { Moment } from 'moment';
import ReactTooltip from 'react-tooltip';
import {
  getBlockedStartDays,
  getHighlightedStartDays,
  getNoon,
} from '../utils/dates';
import { IProperty } from '../utils/types';

import 'react-dates/initialize';
import { DayPickerRangeController, isInclusivelyAfterDay } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import '../styles/calendar.css';

export type Props = {
  property: IProperty;
  offset: number;
};

const Calendar = ({ property, offset }: Props) => {
  const minDate = moment().startOf('month').hour(12);

  const blockedStartDays = useMemo(() => {
    return getBlockedStartDays(minDate, property.avlist);
  }, [minDate, property.avlist]);

  const highlightedStartDays = useMemo(() => {
    return getHighlightedStartDays(minDate, property.avlist);
  }, [minDate, property.avlist]);

  const renderDayContents = (date: Moment) => {
    if (isDayHighlighted(date)) {
      return (
        <div className="CalendarDayInner" data-tip="Checkout Only">
          {date.format('D')}
        </div>
      );
    }
    return <div className="CalendarDayInner">{date.format('D')}</div>;
  };

  const refreshTooltip = () => {
    ReactTooltip.rebuild();
  };

  const isOutsideRange = (date: Moment) => {
    return !isInclusivelyAfterDay(date, getNoon());
  };

  const isDayBlocked = (date: Moment) => {
    return blockedStartDays.has(date.format('YYYYMMDD'));
  };

  const isDayHighlighted = (date: Moment) => {
    return highlightedStartDays.has(date.format('YYYYMMDD'));
  };

  useEffect(() => {
    refreshTooltip();
  }, [property]);

  return (
    <>
      <div className="Calendar__container">
        <div style={{ height: 375 }}>
          <DayPickerRangeController
            disabled // readOnly
            //required
            startDate={null}
            endDate={null}
            focusedInput={'startDate'}
            onDatesChange={() => null}
            onFocusChange={() => null}
            //
            hideKeyboardShortcutsPanel
            keepOpenOnDateSelect
            transitionDuration={0}
            noBorder
            //
            minDate={minDate}
            maxDate={moment(minDate).add(14, 'months').endOf('month')}
            initialVisibleMonth={() => moment().add(offset, 'months')}
            //
            daySize={45}
            numberOfMonths={1}
            horizontalMonthPadding={0}
            //
            noNavButtons
            //
            renderDayContents={renderDayContents}
            isOutsideRange={isOutsideRange}
            isDayBlocked={isDayBlocked}
            isDayHighlighted={isDayHighlighted}
            //
          />
        </div>
      </div>
      <ReactTooltip effect="solid" />
    </>
  );
};

export default Calendar;
